import React,{useState,useEffect} from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AllProjects from "./pages/AllProjects";
import UpComingAllProject from "./pages/upComingAllProject";
import ProjectDetails from "./pages/ProjectDetails";
import UpProjectDetails from "./pages/upcoimingProject";
import EnquiryModal from "./components/EmquiryPopup";
import ChatBot from "./components/ChatBot"


function App() {

   const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 3000); // 3 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    // <BrowserRouter>
    <>
      <EnquiryModal 
        isOpen={showModal} 
        onClose={() => setShowModal(false)} 
      />
      {/* <ChatBot /> */}
     <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<AllProjects />} />
        <Route path="/upcoming-projects" element={<UpComingAllProject />} />
        <Route path="/projects/:slug" element={<ProjectDetails />} />
        <Route path="/upprojects/:slug" element={<UpProjectDetails />} />

      </Routes>
    </>
     
    // </BrowserRouter>
  );
}

export default App;
  